/**
 * Shared render-seed helpers for the Sogni Vibe frontend and server.
 *
 * Keep this module browser-safe: it intentionally has no Node-only imports.
 * `globalThis.crypto` exists in browsers and Node 19+.
 *
 * One seed set is generated per render request and reused across every
 * prompt-variant × model batch, so image position i is seed-matched across
 * models (see docs/superpowers/specs/2026-07-19-shared-render-seeds-design.md).
 */

/**
 * Generate `count` crypto-random seeds, each a Uint32 in 1..0xFFFFFFFF.
 * 0 is excluded so a stored seed can never read as an "unset/random" sentinel.
 *
 * @param {number} count
 * @returns {number[]}
 */
export function generateSeedSet(count) {
  if (!Number.isInteger(count) || count < 0) {
    throw new Error(`Seed count must be a non-negative integer, got ${count}`);
  }
  const seeds = [];
  const buffer = new Uint32Array(1);
  while (seeds.length < count) {
    globalThis.crypto.getRandomValues(buffer);
    if (buffer[0] !== 0) {
      seeds.push(buffer[0]);
    }
  }
  return seeds;
}
